/**
 * Lightweight dev-only logger.
 * - In development: forwards to console.* (debug / info / warn / error)
 * - In production: suppresses debug+info, keeps warn+error for on-call triage
 * Wrap *any* console.* call with this so production builds stay clean.
 */
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  info: (...args) => { if (isDev) console.log(...args); },
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
